export const TOP_OF_UI_STACK = 'TOP_OF_UI_STACK'
export const SIDE_MENU = 'SIDE_MENU'
